export default "__VITE_ASSET__jqQpZ4Qs__"